import React, { useEffect, useMemo, useState, useRef } from "react";
import MDSpinner from "react-md-spinner";
import GoogleMapReact from "google-map-react";
import myConfig from "../../configs/config";
import MapViewportToolbar from "../../components/MapViewportToolbar";
import {
  MAP_VIEWPORT_SCOPES,
  applyViewportToGoogleMap,
  readLocalMapViewport,
  readViewportFromGoogleMap,
  resolveMapViewport,
  writeLocalMapViewport,
} from "../../utils/mapViewport";
import { LAND_PLOT_MAP_STYLE } from "../../utils/mapMeasurements";

import "./Landplot.css";

function MapLandplot({ farm_center, farmId }) {
  const [loading, setLoading] = useState(true);

  const googleRef = useRef(null);
  const mapRef = useRef(null);
  const drawingManagerRef = useRef(null);

  useEffect(() => {
    if (farm_center !== undefined) {
      setLoading(false);
    }
  }, [farm_center]);

  const initialMapViewport = useMemo(() => {
    if (!farm_center) return null;
    return resolveMapViewport({
      localViewport: readLocalMapViewport(MAP_VIEWPORT_SCOPES.LANDPLOT, farmId),
      fallbackCenter: farm_center,
      fallbackZoom: 16,
    });
  }, [farm_center, farmId]);

  function handleSaveMapViewport() {
    if (!mapRef.current) return;
    const viewport = readViewportFromGoogleMap(mapRef.current);
    if (!viewport) return;
    writeLocalMapViewport(MAP_VIEWPORT_SCOPES.LANDPLOT, farmId, viewport);
  }

  function setPolygon(google) {
    let Polygon = new google.maps.Polygon({
      paths: window.path,
      editable: true,
      fillColor: LAND_PLOT_MAP_STYLE.fillColor,
      fillOpacity: LAND_PLOT_MAP_STYLE.fillOpacity,
      strokeColor: LAND_PLOT_MAP_STYLE.strokeColor,
      strokeOpacity: LAND_PLOT_MAP_STYLE.strokeOpacity,
      strokeWeight: LAND_PLOT_MAP_STYLE.strokeWeight,
    });

    Polygon.setMap(google.map);

    google.maps.event.addListener(Polygon, "mouseout", function () {
      let path = Polygon.getPath()
        .getArray()
        .map((latLng) => {
          return { lng: latLng.lng(), lat: latLng.lat() };
        });

      window.path = path;
    });

    function clearPolygon() {
      Polygon.setMap(null);
    }
    google.maps.event.addDomListener(
      document.getElementById("CoordsButton"),
      "click",
      clearPolygon
    );
  }

  function handleGoogleMapApi(google) {
    googleRef.current = google;
    mapRef.current = google.map;
    if (initialMapViewport) {
      applyViewportToGoogleMap(google.map, initialMapViewport);
    }
    setPolygon(google);

    // FERRAMENTAS DE DESENHO DO POLIGONO
    let drawingManager = new google.maps.drawing.DrawingManager({
      drawingControlOptions: {
        drawingModes: ["polygon"],
        position: window.google.maps.ControlPosition.TOP_CENTER,
      },
      drawingControl: true,

      polygonOptions: {
        editable: true,
        fillColor: LAND_PLOT_MAP_STYLE.fillColor,
        fillOpacity: LAND_PLOT_MAP_STYLE.fillOpacity,
        strokeColor: LAND_PLOT_MAP_STYLE.strokeColor,
        strokeOpacity: LAND_PLOT_MAP_STYLE.strokeOpacity,
        strokeWeight: LAND_PLOT_MAP_STYLE.strokeWeight,
      },
    });

    drawingManager.setMap(google.map);
    drawingManagerRef.current = drawingManager;

    // FUNÇÃO PARA TRABALHAR  OS DADOS DO POLIGONO
    google.maps.event.addListener(
      drawingManager,
      "polygoncomplete",
      function (polygon) {
        let path = polygon
          .getPath()
          .getArray()
          .map((latLng) => {
            return { lng: latLng.lng(), lat: latLng.lat() };
          });

        window.path = path;

        drawingManager.setMap(null); //SETAR AS OPÇÕES DE DESENHO

        function clearPolygon() {
          polygon.setMap(null);
          drawingManager.setMap(google.map);
        }
        google.maps.event.addDomListener(
          document.getElementById("CoordsButton"),
          "click",
          clearPolygon
        );
      }
    );
  } //FIM HANDLE

  function getMapOptions(maps) {
    return {
      streetViewControl: true,
      scaleControl: true,
      fullscreenControl: true,
      gestureHandling: "greedy",
      disableDoubleClickZoom: false,
      minZoom: 2,
      mapTypeId: maps.MapTypeId.SATELLITE,
      zoomControl: true,
      clickableIcons: false,
    };
  }

  return (
    <>
      {loading === false ? (
        <div className="map_style">
          <GoogleMapReact
            bootstrapURLKeys={{
              libraries: "drawing",
              key: myConfig.GOOGLE_API_KEY,
              v: "3.64",
            }}
            options={getMapOptions}
            defaultCenter={
              initialMapViewport
                ? {
                    lat: initialMapViewport.lat,
                    lng: initialMapViewport.lng,
                  }
                : { lat: farm_center.ltd, lng: farm_center.lng }
            }
            defaultZoom={initialMapViewport ? initialMapViewport.zoom : 16}
            yesIWantToUseGoogleMapApiInternals={true}
            onGoogleApiLoaded={handleGoogleMapApi}
          />
          <MapViewportToolbar
            onSave={handleSaveMapViewport}
            disabled={!initialMapViewport}
            label="Salvar posição do mapa"
          />

          <input
            type="button"
            defaultValue="Limpar Área"
            id="CoordsButton"
            className="clear_map btn btn-default"
          />
        </div>
      ) : (
        <div
          style={{ marginTop: "50px", marginLeft: "50%", minHeight: "200px" }}
        >
          <MDSpinner />
        </div>
      )}
    </>
  );
}

export default MapLandplot;
